import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'components/App';
import { withDependencies } from 'di/withDependencies';
import config from 'config';

import * as Sentry from '@sentry/browser';

const root = document.getElementById('root');
const app = document.getElementById('app');

if (config.sentry) {
    console.log(`init Sentry w/ the following dsn: ${config.sentry.dsn}`);
    Sentry.init(config.sentry);
}

const props = {
    rootPath: config.deployment.rootPath,
    oidcFlow: config.auth ? config.auth.oidc.flow : undefined,
    logoutUrl: config.deployment.logoutUrl,
    logging: {
        router: ((config.logging || {}).router || false),
    },
    trackingId: config.ga?.trackingId,
};

const container = root ?? app;
if (!container) {
    throw 'no root element found';
}

createRoot(container).render(withDependencies(config, <App {...props} />));
